<template>
  <div class="dashboard-servers">
    <h1 class="title is-5">
      Server
      <b-button
        @click="openServerEditor()"
        class="is-pulled-right"
        outlined
        icon-left="plus"
        size="is-small"
        type="is-primary"
        >Server erstellen
      </b-button>
    </h1>
    <template v-for="server in servers">
      <div :key="server.id" class="card server-card">
        <header class="card-header server-card__header">
          <p class="card-header-title server-card__header__title">
            <span class="server-card__header__title__name">{{
              server.name
            }}</span>
            <b-button
              type="is-text"
              size="is-small"
              rounded
              :icon-right="server.status === 'RUNNING' ? 'external-link' : ''"
              tag="a"
              :href="'https://' + serverDomain(server.domain)"
              target="_blank"
              class="server-card__header__title__link"
              :disabled="server.status !== 'RUNNING'"
            >
              {{ serverDomain(server.domain) }}
            </b-button>
          </p>
          <span class="card-header-icon buttons">
            <b-button
              type="is-success"
              size="is-small"
              outlined
              icon-left="play"
              @click="confirmStartServer(server.id)"
              class="server-card__header__options__item"
              v-if="server.status === 'STOPPED'"
              >Server aktivieren
            </b-button>
            <b-button
              type="is-danger"
              size="is-small"
              outlined
              icon-left="times"
              @click="cancelServer(server.id)"
              class="server-card__header__options__item"
              v-else-if="server.tier.endsWith('P')"
              >Server kündigen
            </b-button>
            <b-button
              type="is-danger"
              size="is-small"
              outlined
              icon-left="pause"
              @click="confirmStopServer(server.id)"
              class="server-card__header__options__item"
              v-else-if="server.status === 'RUNNING'"
              >Server deaktivieren
            </b-button>
            <b-button
              :type="
                'is-' + (server.status === 'STARTING' ? 'success' : 'danger')
              "
              size="is-small"
              outlined
              loading
              disabled
              icon-left="stop"
              class="server-card__header__options__item"
              v-else
              >Server {{ server.status === "STARTING" ? "" : "de" }}aktivieren
            </b-button>
            <b-button
              type="is-primary"
              size="is-small"
              outlined
              icon-left="wrench"
              @click="openServerEditor(server)"
              class="server-card__header__options__item"
              :disabled="server.status !== 'STOPPED'"
            >
              Einstellungen
            </b-button>
          </span>
        </header>
        <footer
          class="card-footer"
          v-if="server.status === 'STOPPED' || server.status === 'RUNNING'"
        >
          <p class="card-footer-item">
            <span>
              <label class="server-card__info__label">Status</label>
              &nbsp;<span
                :class="'server-status--' + server.status"
                class="server-card__info__data server-status"
                >{{ serverStatus(server.status) }}</span
              >
            </span>
          </p>
          <p class="card-footer-item">
            <span v-if="server.status === 'STOPPED'">
              <label class="server-card__info__label">Belegt</label>
              &nbsp;<span class="server-card__info__data">{{
                (server.usages && server.usages[0].value) | gigabytes
              }}</span>
            </span>
            <span v-else>
              <label class="server-card__info__label">Servertyp</label>
              &nbsp;<span class="server-card__info__data">{{
                server.tier
              }}</span>
            </span>
          </p>
          <p class="card-footer-item">
            <span>
              <label class="server-card__info__label"
                ><template v-if="server.status === 'STOPPED'">Inaktiv</template
                ><template v-else>Aktiv</template>
              </label>
              &nbsp;<span class="server-card__info__data"
                ><b-tooltip
                  :label="server.updated_at | formatDateTime"
                  type="is-dark"
                  position="is-bottom"
                  dashed
                >
                  {{
                    (server.usages && server.usages[0].opened_at)
                      | formatRelative
                      | timeSince
                  }}
                </b-tooltip></span
              >
            </span>
          </p>
        </footer>
        <footer class="card-footer" v-else>
          <p class="card-footer-item" style="flex-basis:33.333333%">
            <span>
              <label class="server-card__info__label">Status</label>
              &nbsp;<span
                :class="'server-status--' + server.status"
                class="server-card__info__data server-status"
                >{{ serverStatus(server.status) }}</span
              >
            </span>
          </p>
          <p
            class="card-footer-item"
            style="flex-basis:66.666666%;padding:.5rem .75rem"
          >
            <span style="width:100%;font-size:.8em;text-align:center"
              ><!--<span
                ><span>Schritt 1 von X</span>&nbsp;<strong
                  >Vorbereiten</strong
                ></span
              >--><b-progress
                type="is-primary"
                size="is-small"
                :value="
                  (server.status_progress &&
                    server.status_progress.step_progress) ||
                    undefined
                "
                show-value
                format="percent"
                :precision="0"
              ></b-progress
            ></span>
          </p>
        </footer>
      </div>
    </template>

    <b-modal
      :active.sync="isServerEditorOpen"
      aria-modal
      aria-role="dialog"
      has-modal-card
      trap-focus
    >
      <ServerEditor :server="serverEditorData" @changed="getServers" />
    </b-modal>
  </div>
</template>

<script>
import ServerEditor from "../../components/ServerEditor";
export default {
  name: "DashboardServers",
  components: { ServerEditor },
  data() {
    return {
      //createSubdomain: "",
      //createCustomSubdomain: false,
      //useCustomDomain: false,
      //isCreateModalActive: false,
      //createModalPerformanceLevel: null,
      //openConfig: null,
      isServerEditorOpen: false,
      serverEditorData: null,
      servers: [
        // {
        //   id: 123,
        //   name: "Test Server",
        //   domain: "test-server",
        //   status: "RUNNING",
        //   level: "S",
        //   changed_at: "2 Stunden"
        // },
        // {
        //   id: 321,
        //   name: "Test Server 2",
        //   domain: "test-server.my-domain.de",
        //   status: "STOPPED",
        //   image_size: "7.42",
        //   changed_at: "23 Tagen"
        // }
      ],
      loading: false,
      autoUpdater: null,
      autoUpdateTimeout: 30000
    };
  },
  methods: {
    startServer: function(serverId) {
      this.$store.state.api.servers
        .start(serverId)
        .then(response => {
          console.log(response);
          if (response.data) {
            this.$buefy.toast.open("Server wird gestartet...");
            this.getServers();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    stopServer: function(serverId) {
      this.$store.state.api.servers
        .stop(serverId)
        .then(response => {
          console.log(response);
          if (response.data) {
            this.$buefy.toast.open("Server wird gestoppt...");
            this.getServers();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    openServerEditor: function(server) {
      this.serverEditorData = server;
      this.isServerEditorOpen = true;
    },
    serverDomain: function(domain) {
      if (domain.indexOf(".") !== -1) return domain;

      return domain + ".confcloud.de";
    },
    serverStatus: function(status) {
      if (status === "INITIALIZING") return "Initialisierung...";
      if (status === "RUNNING") return "Aktiv";
      if (status === "STOPPED") return "Inaktiv";
      if (status === "STARTING") return "Startet...";
      if (status === "STOPPING") return "Stoppen...";
      if (status === "DELETING") return "Löschen...";

      return "Unbekannt";
    },
    getServers() {
      this.loading = true;
      this.$store.state.api.servers
        .get()
        .then(response => {
          this.servers = response.data;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loading = false;
        });
    },
    confirmStartServer(serverId) {
      this.$buefy.dialog.confirm({
        message: `Durch aktiveren dieses Servers entstehen Kosten entsprechend der gewählten Leistung. Das Aktivieren des Servers dauert circa 5 Minuten, währenddessen können keine Änderungen vorgenommen werden.<br><br>Der Vorgang läuft im Hintergrund, du kannst deinen Browser in der Zwischenzeit schließen.`,
        confirmText: "Jetzt aktivieren",
        cancelText: "Abbrechen",
        type: "is-success",
        ariaRole: "alertdialog",
        ariaModal: true,
        onConfirm: () => this.startServer(serverId)
      });
    },
    confirmStopServer(serverId) {
      this.$buefy.dialog.confirm({
        message: `Durch deaktivieren dieses Servers entstehen Kosten entsprechend des benötigten Speicherplatzes. Das Deaktivieren des Servers dauert circa 10 Minuten, währenddessen können keine Änderungen vorgenommen werden.<br><br>Der Vorgang läuft im Hintergrund, du kannst deinen Browser in der Zwischenzeit schließen.`,
        confirmText: "Jetzt deaktivieren",
        cancelText: "Abbrechen",
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true,
        onConfirm: () => this.stopServer(serverId)
      });
    },
    cancelServer(serverName, serverId) {
      window.location.href =
        "mailto:info@confcloud.de?subject=Kündigung Server " +
        serverName +
        " (#S" +
        serverId +
        ")&body=";
    }
  },
  created() {
    this.getServers();
    this.autoUpdater = setInterval(this.getServers, this.autoUpdateTimeout);
  },
  beforeDestroy() {
    clearInterval(this.autoUpdater);
  }
};
</script>

<style lang="scss">
.server-card {
  margin: 1.5rem 0;

  &__header {
    &__title__link {
      margin-left: 0.5rem;
      text-decoration: none !important;
    }
    &__options__item {
      & + & {
        //margin-left: 0.5rem;
      }
    }
  }

  &__info__data {
    font-weight: 500;
  }

  @media (max-width: 767px) {
    &__header {
      display: flex;
      flex-direction: column;

      .buttons {
        justify-content: flex-end;
      }
    }
  }
}

.server-status {
  &--RUNNING {
    color: $success;
  }

  &--STOPPED {
    color: $danger;
  }

  &--STARTING {
    color: $info;
  }

  &--STOPPING {
    color: $warning;
  }

  &--INITIALIZING {
    color: $primary;
  }

  &--DELETING {
    color: $black;
  }
}
</style>
